import {AccessorsMutatorsDecorator} from "../../helpers";
import {TranslatableModel} from "./translatable-model";


export class PaytabsTransaction extends TranslatableModel {}

AccessorsMutatorsDecorator(
    'id',
    'transaction_id',
    'order_id',
    'response_code',
    'response_message',
    'customer_name',
    'customer_email',
    'customer_phone',
    'transaction_amount',
    'transaction_currency',
    'last_4_digits',
    'first_4_digits',
    'card_brand',
    'trans_date',
    'address_shipping',
    'city_shipping',
    'state_shipping',
    'country_shipping',
    'postal_code_shipping',
    'secure_sign',
    'pt_customer_email',
    'pt_customer_password',
    'pt_token',
)(PaytabsTransaction);


// WEBPACK FOOTER //
// ./src/pms-api/models/paytabs-transaction.model.js